import Vue from 'vue'
import Vuex from 'vuex'

import { Module, createStore } from 'vuex-smart-module'

import { depHeadPartner } from '@/store/modules/depHeadPartner'
import { dicts } from './modules/dicts'
import { loading } from './modules/loading'
import { logger } from './modules/logger'
import { mobileWidth } from '@/store/modules/mobileWidth'
import { navBarTitle } from './modules/navbar'
import { notifications } from '@/store/modules/notifications'
import { partner } from '@/store/modules/partner'
import { prManager } from '@/store/modules/prManager'
import { toast } from './modules/toast'
import { user } from './modules/user'

Vue.use(Vuex)

const root = new Module({
  modules: {
    depHeadPartner,
    dicts,
    loading,
    logger,
    mobileWidth,
    navBarTitle,
    notifications,
    partner,
    prManager,
    toast,
    user
  }
})

export default createStore(root)
